import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-language-selection',
  templateUrl: './language-selection.component.html',
  styleUrls: ['./language-selection.component.scss']
})
export class LanguageSelectionComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<LanguageSelectionComponent>
  ) { }
  url = window.location.origin

  ngOnInit(): void {
  }

}
